import React from 'react';
import questionFillIcon from '../../assets/images/question-fill.svg';
import './SectionHeader.less';

export interface SectionHeaderProps {
  title: React.ReactNode;
  /** Optional update date shown on the right, already formatted for display. */
  updateDate?: string;
  /** Show the question/help icon next to the title. */
  showHelp?: boolean;
  /** Accessible label / handler for the help icon. */
  onHelpClick?: () => void;
  className?: string;
  dataNodeId?: string;
  /** Heading level for semantics; visual style stays the same. */
  as?: 'h1' | 'h2' | 'h3';
}

/**
 * Figma Section / Header.
 * Reference node: 3144:5135, 626x29, left red border, title, help icon, date.
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  updateDate,
  showHelp = false,
  onHelpClick,
  className,
  dataNodeId,
  as: Heading = 'h2',
}) => {
  const icon = (
    <img
      className="section-header__help-icon"
      src={questionFillIcon}
      alt=""
      aria-hidden="true"
    />
  );

  const helpIcon = showHelp ? (
    onHelpClick ? (
      <button
        type="button"
        className="section-header__help"
        aria-label="この項目の説明"
        onClick={onHelpClick}
      >
        {icon}
      </button>
    ) : (
      <span className="section-header__help" aria-hidden="true">
        {icon}
      </span>
    )
  ) : null;

  return (
    <div
      className={`section-header${className ? ` ${className}` : ''}`}
      data-node-id={dataNodeId}
    >
      <Heading className="section-header__title">{title}</Heading>
      {helpIcon}
      {updateDate && <span className="section-header__date">{updateDate}</span>}
    </div>
  );
};

export default SectionHeader;
